import { GetStaticProps, InferGetStaticPropsType } from 'next';
import type { NextPageWithLayout } from 'types/page';
import {
  SCREEN_HEIGHT_SIDEBAR_LAYOUT_PROPS,
  withSidebarLayout,
} from 'layouts/SidebarPage/withSidebarLayout';
import LandingPage from 'screens/WebSite/LandingPage';
import OptionFlowPage from 'screens/OptionFlowPage';
import { getIsNativePlatform } from 'utils/client/mobile';
import { combineJsonLdSchemas } from 'utils/shared/jsonLd/combineJsonLdSchemas';
import {
  generateOrganizationJsonLd,
  generateWebSiteJsonLd,
} from 'utils/shared/jsonLd/organization';
import { generateSoftwareApplicationJsonLd } from 'utils/shared/jsonLd/softwareApplication';

export const getStaticProps: GetStaticProps<{ jsonLd: string }> = async () => {
  const organizationJsonLd = generateOrganizationJsonLd();
  const webSiteJsonLd = generateWebSiteJsonLd();
  const softwareAppJsonLd = generateSoftwareApplicationJsonLd();

  const combinedSchemas = combineJsonLdSchemas([
    organizationJsonLd,
    webSiteJsonLd,
    softwareAppJsonLd,
  ]);

  return {
    props: {
      jsonLd: JSON.stringify(combinedSchemas),
    },
  };
};

const isMobileApp = () => getIsNativePlatform() || process.env.TARGET_PLATFORM === 'MOBILE';

const Index: NextPageWithLayout<InferGetStaticPropsType<typeof getStaticProps>> = ({ jsonLd }) => {
  if (isMobileApp()) {
    return <OptionFlowPage />;
  } else {
    return <LandingPage jsonLd={jsonLd} />;
  }
};

const withFlowSidebarLayout = withSidebarLayout(SCREEN_HEIGHT_SIDEBAR_LAYOUT_PROPS);

// The native app boots into `/`, which renders the flow dashboard instead of the
// landing page. It must get the same sidebar layout as /flow — isScreenHeight is
// what keeps the page from scrolling down to the SEO-only FlowDescription text.
Index.getLayout = (page) => (isMobileApp() ? withFlowSidebarLayout(page) : page);

export default Index;
